/** Link-only integration: validate without rewriting signed query parameters. */
export function isValidExternalFolderUrl(value: string): boolean {
  const url = value.trim();
  if (
    !url ||
    url.length > 2048 ||
    !/^https:\/\//i.test(url) ||
    url.includes('\\') ||
    [...url].some(char => char.charCodeAt(0) < 32 || (char.charCodeAt(0) >= 127 && char.charCodeAt(0) <= 159))
  )
    return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && !!parsed.hostname && !parsed.username && !parsed.password;
  } catch {
    return false;
  }
}
